import React, { useState, useEffect } from 'react';
import { Card, Col, Container } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { BackButton } from '../../../components/Common/BackButton';
import Breadcrumb from '../../../components/Common/Breadcrumb';
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton';
import { SearchBar } from '../../../components/Common/SearchBar';
import Table1 from "../../../components/Common/TableContainer";
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal';
import { getKinds, updateKind, addNewKind, deleteKind, updateKindStatus } from "../../../store/catalogs/Kinds/actions";
import { KindRegisterModal } from './KindRegisterModal';

const CatalogLayoutKinds = (props) => {

    // Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getKinds("?limit=20&page=0"));
    }, []);

    const { kinds, loading, total, currentPage } = useSelector(state => ({
        kinds: state.kinds.kinds,
        loading: state.kinds.loading,
        total: state.kinds.total,
        currentPage: state.kinds.currentPage
    }));

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getKinds(`?limit=20&page=0&search=${searchData}`));
    }, [searchData]);

    const onUpdate = (values) => {
        setIsUpdate(true);
        setRowInfo(values);
        setShowModal1(true);
    };

    const onDelete = (values) => {
        setRowInfo(values);
        setShowModal2(true);
    };

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id };
            dispatch(updateKind(updValue));
            dispatch(updateKindStatus({ id: rowInfo.id, recordStatus: active }));
        } else {
            dispatch(addNewKind(values));
        }
        setTimeout(() => {
            dispatch(getKinds("?limit=20&page=0"));
        }, 500);
        setIsUpdate(false);
        setRowInfo('');
    };

    const modalClose = () => {
        setIsUpdate(false);
    };

    const onDeleteConfirmation = () => {
        dispatch(deleteKind(rowInfo));
        setRowInfo('');
    };

    const getPagination = (params) => {
        dispatch(getKinds(`${params}&search=${searchData}`));
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'Clase',
                accessor: 'name',
                width: 400,
            },
            {
                Header: 'Estatus',
                width: '15%',
                Cell: ({ row }) => (
                    row.original.recordStatus
                        ? <div className='text-success'>Activo</div>
                        : <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    );

    return (
        <div className="page-content">
            <Container fluid>
                <Col className="col-12" style={{ padding: 40 }}>
                    <Card style={{ padding: 20 }}>

                        <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='KindsCatalog' />

                        <Card style={{ padding: 20 }}>
                            <div className='pe-1'>
                                <BackButton props={props} />
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-9 mb-2 ps-3 pe-3">
                                    <SearchBar setSearchData={setSearchData} />
                                </div>
                                <div className="col-12 col-lg-3 pe-3">
                                    <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                </div>
                            </div>

                            <div className='ms-1'>
                                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={kinds} />
                            </div>

                            <KindRegisterModal
                                setShowModal={setShowModal1}
                                showModal={showModal1}
                                modalRespInfo={RegisterModalRespInfo}
                                isUpdate={isUpdate}
                                rowInfo={rowInfo}
                                modalClose={modalClose}
                            />

                            <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar clase' modalBodyLabel='¿Está seguro que desea eliminar la clase de material seleccionada?' />
                        </Card>
                    </Card>
                </Col>
                <ToastContainer autoClose={2000} newestOnTop />
            </Container>
        </div>
    );
};

export default CatalogLayoutKinds;